
export const keys = {
    all: ["ui-customization"],

    settings: () => [
        ...keys.all,
        "settings"
    ],
    userSettings: (userID: number) => [
        ...keys.settings(),
        {
            userID
        }
    ],

    effectiveSettings: () => [
        ...keys.all,
        "effectiveSettings"
    ],
    userEffectiveSettings: (userID: number) => [
        ...keys.effectiveSettings(), {
            userID
        }
    ],

    presetLists: () => [
        ...keys.all,
        "presets"
    ],
    presetList: (organizationID: number) => [
        ...keys.presetLists(),
        {
            organizationID
        }
    ],
    
    presets: () => [
        ...keys.all,
        "presets"
    ],
    preset: (presetID: number) => [
        ...keys.presets(),
        {
            presetID
        }
    ],

    presetsUserLists: () => [
        ...keys.all,
        "preset-users"
    ],
    presetUserList: (presetID: number) => [
        ...keys.presetsUserLists(),
        {
            presetID
        }
    ]
};
